import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["canvas", "canvasData", "typedSignature", "typeInput", "drawInput", "method", "typeBtn", "drawBtn"]

  connect() {
    this.isDrawing = false
    this.lastX = 0
    this.lastY = 0

    if (this.hasCanvasTarget) {
      this.setupCanvas()
    }
  }

  setupCanvas() {
    const canvas = this.canvasTarget
    this.ctx = canvas.getContext("2d")

    // Set canvas resolution to match display size
    const rect = canvas.getBoundingClientRect()
    canvas.width = rect.width * 2
    canvas.height = rect.height * 2
    this.ctx.scale(2, 2)

    this.ctx.strokeStyle = "#1a1a1a"
    this.ctx.lineWidth = 2
    this.ctx.lineCap = "round"
    this.ctx.lineJoin = "round"

    // Mouse events
    canvas.addEventListener("mousedown", (e) => this.startDrawing(e))
    canvas.addEventListener("mousemove", (e) => this.draw(e))
    canvas.addEventListener("mouseup", () => this.stopDrawing())
    canvas.addEventListener("mouseout", () => this.stopDrawing())

    // Touch events
    canvas.addEventListener("touchstart", (e) => this.startDrawing(e))
    canvas.addEventListener("touchmove", (e) => this.draw(e))
    canvas.addEventListener("touchend", () => this.stopDrawing())
  }

  getPosition(e) {
    const canvas = this.canvasTarget
    const rect = canvas.getBoundingClientRect()

    if (e.touches && e.touches.length > 0) {
      return {
        x: e.touches[0].clientX - rect.left,
        y: e.touches[0].clientY - rect.top
      }
    }

    return {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    }
  }

  startDrawing(e) {
    e.preventDefault()
    this.isDrawing = true
    const pos = this.getPosition(e)
    this.lastX = pos.x
    this.lastY = pos.y
  }

  draw(e) {
    if (!this.isDrawing) return
    e.preventDefault()

    const pos = this.getPosition(e)

    this.ctx.beginPath()
    this.ctx.moveTo(this.lastX, this.lastY)
    this.ctx.lineTo(pos.x, pos.y)
    this.ctx.stroke()

    this.lastX = pos.x
    this.lastY = pos.y
  }

  stopDrawing() {
    if (!this.isDrawing) return
    this.isDrawing = false

    // Save canvas data as base64
    if (this.hasCanvasDataTarget) {
      this.canvasDataTarget.value = this.canvasTarget.toDataURL("image/png")
    }
  }

  clearCanvas() {
    if (!this.hasCanvasTarget) return

    const canvas = this.canvasTarget
    const rect = canvas.getBoundingClientRect()
    this.ctx.clearRect(0, 0, rect.width, rect.height)

    if (this.hasCanvasDataTarget) {
      this.canvasDataTarget.value = ""
    }
  }

  switchToType() {
    if (this.hasTypeInputTarget) this.typeInputTarget.classList.remove("hidden")
    if (this.hasDrawInputTarget) this.drawInputTarget.classList.add("hidden")
    if (this.hasMethodTarget) this.methodTarget.value = "type"

    // Style buttons
    if (this.hasTypeBtnTarget) {
      this.typeBtnTarget.classList.add("text-white", "bg-indigo-600", "border-indigo-600")
      this.typeBtnTarget.classList.remove("text-gray-700", "bg-white", "border-gray-300")
    }
    if (this.hasDrawBtnTarget) {
      this.drawBtnTarget.classList.remove("text-white", "bg-indigo-600", "border-indigo-600")
      this.drawBtnTarget.classList.add("text-gray-700", "bg-white", "border-gray-300")
    }
  }

  switchToDraw() {
    if (this.hasTypeInputTarget) this.typeInputTarget.classList.add("hidden")
    if (this.hasDrawInputTarget) this.drawInputTarget.classList.remove("hidden")
    if (this.hasMethodTarget) this.methodTarget.value = "draw"

    // Style buttons
    if (this.hasDrawBtnTarget) {
      this.drawBtnTarget.classList.add("text-white", "bg-indigo-600", "border-indigo-600")
      this.drawBtnTarget.classList.remove("text-gray-700", "bg-white", "border-gray-300")
    }
    if (this.hasTypeBtnTarget) {
      this.typeBtnTarget.classList.remove("text-white", "bg-indigo-600", "border-indigo-600")
      this.typeBtnTarget.classList.add("text-gray-700", "bg-white", "border-gray-300")
    }

    // Re-setup canvas if needed (size may have changed)
    if (this.hasCanvasTarget && !this.ctx) {
      this.setupCanvas()
    }
  }
}
